var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarriageCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-landscape 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29 5H11C9.34315 5 8 6.67893 8 8.75V31.25C8 33.3211 9.34315 35 11 35H29C30.6569 35 32 33.3211 32 31.25V8.75C32 6.67893 30.6569 5 29 5Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.27 20.9041C25.2111 20.7277 25.0983 20.5744 24.9476 20.4656C24.7968 20.3568 24.6157 20.2981 24.4298 20.2978H21.7709V17.6411C22.1722 17.282 22.4551 16.8096 22.5821 16.2863C22.7092 15.7629 22.6743 15.2134 22.4821 14.7103C22.29 14.2072 21.9496 13.7743 21.5061 13.4689C21.0625 13.1635 20.5367 13 19.9982 13C19.4597 13 18.9339 13.1635 18.4904 13.4689C18.0468 13.7743 17.7065 14.2072 17.5143 14.7103C17.3222 15.2134 17.2873 15.7629 17.4143 16.2863C17.5413 16.8096 17.8242 17.282 18.2256 17.6411V20.3002H15.569C15.3829 20.3002 15.2016 20.3588 15.0506 20.4676C14.8996 20.5764 14.7866 20.7299 14.7276 20.9064L13.5459 24.4519C13.5012 24.5852 13.4889 24.7272 13.51 24.8661C13.5312 25.0051 13.5851 25.137 13.6673 25.251C13.7495 25.365 13.8577 25.4578 13.9829 25.5217C14.1081 25.5855 14.2467 25.6187 14.3873 25.6183H25.6139C25.7544 25.6185 25.8928 25.5852 26.0179 25.5213C26.1429 25.4573 26.251 25.3645 26.3331 25.2505C26.4152 25.1366 26.469 25.0047 26.49 24.8658C26.5111 24.7269 26.4988 24.5851 26.4541 24.4519L25.27 20.9041Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarriageCertificate);
export default __webpack_public_path__ + "static/media/marriage_certificate.4e6dddec774314c06c05699ea62a62f7.svg";
export { ForwardRef as ReactComponent };